export var DEFAULT_AVATAR = '🤖';
export var DEFAULT_USER_AVATAR = '😀';